import { render } from "./SpotlightCard.vue?vue&type=template&id=2a70d380&scoped=true"
import script from "./SpotlightCard.vue?vue&type=script&lang=js"
export * from "./SpotlightCard.vue?vue&type=script&lang=js"

import "./SpotlightCard.vue?vue&type=style&index=0&id=2a70d380&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a70d380"]])

export default __exports__